import { isoDate, weekdayForDate } from './math.js';
const LOCAL_TIME = /^([01]\d|2[0-3]):[0-5]\d$/;
const ISO_DATE = /^\d{4}-\d{2}-\d{2}$/;
export function validateNotifySlots(slots) {
    const errors = [];
    if (slots.length > 40)
        errors.push('slots.max');
    slots.forEach((slot, index) => {
        if (!LOCAL_TIME.test(slot.localTime))
            errors.push(`slots.${index}.localTime`);
        if (!Number.isInteger(slot.weekdayMask) || slot.weekdayMask < 1 || slot.weekdayMask > 127)
            errors.push(`slots.${index}.weekdayMask`);
        if (typeof slot.labelToken !== 'string' || slot.labelToken.trim().length < 1 || slot.labelToken.trim().length > 20)
            errors.push(`slots.${index}.labelToken`);
        if (slot.activeDate != null && !ISO_DATE.test(slot.activeDate))
            errors.push(`slots.${index}.activeDate`);
        if (slot.slotKey != null && !/^[a-zA-Z0-9_.:-]{1,100}$/.test(slot.slotKey))
            errors.push(`slots.${index}.slotKey`);
        if (slot.followUpMinutes != null && slot.followUpMinutes !== 30)
            errors.push(`slots.${index}.followUpMinutes`);
        if (slot.pausedUntil != null && !ISO_DATE.test(slot.pausedUntil))
            errors.push(`slots.${index}.pausedUntil`);
        for (const key of ['startDate', 'endDate', 'anchorDate'])
            if (slot[key] != null && (!ISO_DATE.test(slot[key]) || !Number.isFinite(Date.parse(`${slot[key]}T00:00:00Z`)) || new Date(`${slot[key]}T00:00:00Z`).toISOString().slice(0, 10) !== slot[key]))
                errors.push(`slots.${index}.${key}`);
        if (slot.startDate && slot.endDate && slot.startDate > slot.endDate)
            errors.push(`slots.${index}.range`);
        if (slot.everyDays != null && (!Number.isInteger(slot.everyDays) || slot.everyDays < 1 || slot.everyDays > 365 || !slot.anchorDate))
            errors.push(`slots.${index}.everyDays`);
        if (typeof slot.active !== 'boolean')
            errors.push(`slots.${index}.active`);
    });
    return errors;
}
function localParts(epoch, timeZone) {
    const date = isoDate(epoch, timeZone);
    const parts = new Intl.DateTimeFormat('en-US', { timeZone, hourCycle: 'h23', hour: '2-digit', minute: '2-digit' }).formatToParts(new Date(epoch));
    const values = Object.fromEntries(parts.filter((part) => part.type !== 'literal').map((part) => [part.type, Number(part.value)]));
    const localTime = `${String(values.hour ?? 0).padStart(2, '0')}:${String(values.minute ?? 0).padStart(2, '0')}`;
    return { date, localTime, weekday: weekdayForDate(date) };
}
/** cron 실행 간격(분). wrangler.toml의 5분 간격 cron과 같다. */
export const NOTIFY_WINDOW_MINUTES = 5;
/**
 * 슬롯 시각이 (now − 창, now] 구간에 들어오면 이번 실행에서 보낸다.
 * cron은 5분 간격이라 분 단위 일치만 보면 08:03 같은 시각이 영원히 울리지 않는다.
 * 서버에는 이 슬롯의 시각·표시 토큰만 전달하고, 로컬 처치명이나 건강값은 포함하지 않는다.
 */
export function slotFallsInWindow(slot, now, timeZone, windowMinutes = NOTIFY_WINDOW_MINUTES) {
    if (!slot.active)
        return false;
    for (let back = 0; back < windowMinutes; back += 1) {
        const current = localParts(now - back * 60_000, timeZone);
        if (slot.localTime !== current.localTime)
            continue;
        if ((slot.startDate && current.date < slot.startDate) || (slot.endDate && current.date > slot.endDate))
            continue;
        if (slot.everyDays && slot.anchorDate) {
            const days = (Date.parse(`${current.date}T00:00:00Z`) - Date.parse(`${slot.anchorDate}T00:00:00Z`)) / 86400000;
            if (days < 0 || days % slot.everyDays !== 0)
                continue;
        }
        if (slot.activeDate ? slot.activeDate === current.date : (slot.weekdayMask & (1 << current.weekday)) !== 0)
            return true;
    }
    return false;
}
export function dueNotifySlots(now, slots, timeZone, windowMinutes = NOTIFY_WINDOW_MINUTES) {
    const errors = validateNotifySlots(slots);
    if (errors.length)
        return [];
    return slots.filter((slot) => (!slot.pausedUntil || isoDate(now, timeZone) > slot.pausedUntil) && slotFallsInWindow(slot, now, timeZone, windowMinutes));
}
export function visitReminderDate(nextVisitDate) {
    if (!ISO_DATE.test(nextVisitDate))
        return null;
    const date = new Date(`${nextVisitDate}T00:00:00Z`);
    if (!Number.isFinite(date.getTime()))
        return null;
    date.setUTCDate(date.getUTCDate() - 7);
    return date.toISOString().slice(0, 10);
}
